import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { CONTENT_URL_ACCEPTABLE_USE_POLICY, CONTENT_URL_AI_TROUBLESHOOTING } from '../constants';
import { messages } from '../messages';
export var getIsAISummaryEnabled = function getIsAISummaryEnabled() {
  var _response$meta;
  var isAdminHubAIEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var response = arguments.length > 1 ? arguments[1] : undefined;
  return Boolean(getBooleanFF('platform.linking-platform.smart-card.hover-card-ai-summaries') && isAdminHubAIEnabled && (response === null || response === void 0 || (_response$meta = response.meta) === null || _response$meta === void 0 || (_response$meta = _response$meta.supportedFeature) === null || _response$meta === void 0 ? void 0 : _response$meta.includes('AISummary')));
};
export var getAISummaryErrorMessage = function getAISummaryErrorMessage(error) {
  switch (error) {
    case 'ACCEPTABLE_USE_VIOLATIONS':
      return {
        message: messages.ai_summary_error_acceptable_use_violation,
        url: CONTENT_URL_ACCEPTABLE_USE_POLICY
      };
    case 'HIPAA_CONTENT_DETECTED':
      return {
        message: messages.ai_summary_error_hipaa_content_detected
      };
    case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
      return {
        message: messages.ai_summary_error_exceeding_context_length_error
      };
    default:
      return {
        message: messages.ai_summary_error_generic,
        url: CONTENT_URL_AI_TROUBLESHOOTING
      };
  }
};